export default __webpack_public_path__ + "static/B39-40e3430624844c43b732f2841a8b061c.png";